import React from 'react';
import { AppShell } from './AppShell';

export const CustomerLayout: React.FC = () => <AppShell variant="customer" />;
